import { create } from 'zustand';

const useUserStore = create((set) => ({
  user: null,
  token: null,
  subscription: null,
  setAll: (user, token, subscription) => set({ user, token, subscription }),
  logout: () => set({ user: null, token: null, subscription: null }),
}));

export default useUserStore;
